import { IHandleBoolean } from '_constants';

const HandleBoolean: React.FC<IHandleBoolean> = ({ value, trueText, falseText }) => {
  return <div title={value ? trueText : falseText}>{value ? trueText : falseText}</div>;
};

export default HandleBoolean;
